/**
 * Created by JIocb on 15.06.2017.
 */
namespace Factive.Game
{
    export enum DiceRollingBoxEventType
    {
        ROLL_COMPLETE,
        DICE_SELECTED,
        COLOR_BONUS
    }
};


// WEBPACK FOOTER //
// src/typescript/Game/Engine/View/DiceRollingBoxEventType.ts